module.exports = __webpack_public_path__ + "static/media/moderator-icon.84d6b639.svg";